/**
 * Resolve deep object value
 * @example resolve({ a: {b: 2}}, e => e.a.b, 0): 2, if object value is exist, if not = 0;
 * @param object
 * @param fn
 * @param defaultValue
 */
export const resolve = <T, B>(
    object: T,
    fn: (object: T) => B,
    defaultValue: B
): B => {
    try {
        const result = fn(object);

        return result === undefined ? defaultValue : result;
    } catch (e) {
        return defaultValue;
    }
};
